module.exports = __webpack_public_path__ + "media/images/lp_check-24d02b0c86f98adad4311e68ef7adfe9.webp";